module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "otherfm1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSO BY")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AREN")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AWKINS")])])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "center1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URST")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MULET")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIES")]), _c('br'), _c('em', [_vm._v("One Night in Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACLEAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URSE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIES")]), _c('br'), _c('em', [_vm._v("How to Abduct a Highland Lord"), _c('br'), _vm._v("To Scotland, With Love"), _c('br'), _vm._v("To Catch a Highlander"), _c('br'), _vm._v("Sleepless in Scotland"), _c('br'), _vm._v("The Laird Who Loved Me")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REQUEL TO THE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URST")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MULET"), _c('br'), _vm._v("AND")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACLEAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URSE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIES")]), _c('br'), _c('em', [_vm._v("Much Ado About Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTEMPORARY")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANCE")]), _c('br'), _c('em', [_vm._v("Talk of the Town"), _c('br'), _vm._v("Lois Lane Tells All")])]), _vm._v(" "), _c('p', {
    staticClass: "centerc1"
  }, [_vm._v("Available from Pocket Books")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b51bc6a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/otherfm1.vue
// module id = 66
// module chunks = 0